import { useQuery } from '@tanstack/react-query';
import { IPurchaseContractRelationType } from '../../Interfaces/IPurchaseContractRelationType';
import { customFetcher } from '../useFetch';

//////////////////// PurchaseContractRelationType
export const useGePurchaseContractRelationType = () => {
  const {
    data: purchaseContractRelationTypes,
    isLoading: isLoadingPurchaseContractRelationTypes,
  } = useQuery<IPurchaseContractRelationType[]>({
    refetchOnWindowFocus: false,
    queryKey: ['purchasecontractrelationtype'],
    queryFn: () =>
      customFetcher({
        endpoint: '/purchasecontractrelationtype',
      }),
  });

  return {
    purchaseContractRelationTypes,
    isLoadingPurchaseContractRelationTypes,
  };
};
